import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import BASE_URL from "components/BaseUrl/apiConfig";
import Navbar from "components/Navbars/IndexNavbar";
import Footer from "components/Footers/Footer";
import Swal from "sweetalert2";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import AnimatedCard from "react-animated-3d-card";
import ExpenseImage from "../../assets/img/ExpensesManagement.jpg";
import NotesImage from "../../assets/img/NotesManagement.jpg";
import DocumentImage from "../../assets/img/DocumentLibrarayManagement.jpg";
import QuantityImage from "../../assets/img/QuantityManagement.jpg";
import MarketingImage from "../../assets/img/EmailMarketing.jpg";

import {
  setLocalStorageData,
  getLocalStorageData,
  resetSessionTimeout,
  removeLocalStorageData,
  setupSessionTimeoutListener,
} from "./localStorageUtil";

export default function Login() {
  const history = useHistory();
  const userNameInputRef = useRef(null);

  const [formData, setFormData] = useState({
    password: "",
    userName: "",
  });

  const [errors, setErrors] = useState({
    password: "",
    userName: "",
  });

  const [hoveredCard, setHoveredCard] = useState(null);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Focus on the userName input when the component mounts
    userNameInputRef.current.focus();

    setupSessionTimeoutListener();
  }, []);

  const handleCardClick = (title, description) => {
    Swal.fire({
      title: title,
      text: description,
      // icon: "info",
      imageUrl: require("assets/img/essentials_small.png"), // Path to your image
      imageWidth: 200, // Adjust the width as needed
      imageHeight: 50, // Adjust the height as needed
      confirmButtonText: "Okay",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear the error for the changed field
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    const newErrors = {};
    if (!formData.userName.trim()) {
      newErrors.userName = "Username is required.";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required.";
    }

    if (Object.keys(newErrors).length > 0) {
      // There are validation errors
      setErrors(newErrors);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/api/Users/Login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: formData.userName,
          password: formData.password,
        }),
      });

      if (!response.ok) {
        // Handle unsuccessful login (e.g., display an error message)
        const errorData = await response.json();

        setLoading(false);

        if (errorData.msg === "Please Verify your Email!") {
          history.push("/verifyEmail");

          Swal.fire({
            icon: "error",
            title: "Verify Email",
            text: "Your Email is not Verified. Please Verify your Email! ",
          });

          return;
        } else if (errorData.msg === "Please contact your administrator.") {
          Swal.fire({
            icon: "error",
            title: "Something went wrong.",
            text: "Please contact your administrator.",
          });

          return;
        }

        Swal.fire({
          icon: "error",
          title: "Invalid credentials.",
          text: errorData.msg,
        });

        return;
      }

      const responseData = await response.json();

      if (responseData.success) {
        const userData = responseData.user;
        // console.log(responseData.user);
        // Store user data in local storage
        setLocalStorageData({
          userName: userData.userName,
          userId: userData.userId,
          userTypeId: userData.userTypeId,
          groupId: userData.groupId,
          fullName: userData.fullName,
        });

        if (userData.userTypeId === 1) {
          history.push("/admindashboard");
        } else {
          // Redirect to the dashboard or desired page
          history.push("/dashboard"); // Replace '/dashboard' with your actual dashboard route
        }

        setLoading(false);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong.",
        text: error,
      });
      setLoading(false);
    }
  };
  const imageExpenseTracking =
    "https://img.freepik.com/free-vector/bill-analysis-concept-illustration_114360-22918.jpg?t=st=1722490505~exp=1722494105~hmac=bdeae48963705d1e2cc43ccac5ef790897bf82b18de10be832b91d8b4caf6c26&w=740";

  const quantityTracking =
    "https://img.freepik.com/free-vector/charts-concept-illustration_114360-91.jpg?t=st=1722489740~exp=1722493340~hmac=4ab0d6451c3925457a2413d1df21073b1633390f1c83471df1447ae6ff1aa781&w=740";

  const notesimage =
    "https://img.freepik.com/free-vector/hand-drawn-essay-illustration_23-2150268421.jpg?t=st=1722490677~exp=1722494277~hmac=35e42c5169dacbcf6fdab87fc7a11bdb9ea640791dcc6b44b335b0ded97d096b&w=740";

  const documentimg =
    "https://img.freepik.com/free-vector/app-data-concept-illustration_114360-4423.jpg?t=st=1722490797~exp=1722494397~hmac=1225b73792fe4533d7e02d871c2ad9cdb360133f8ec390d7c6c139eb2e6f2662&w=740";

  const marketingimg =
    "https://img.freepik.com/premium-vector/passive-income-abstract-concept-vector-illustration_107173-24812.jpg?w=740";
  return (
    <>
      <Navbar />
      <div className="min-h-content-minvh">
        <div className="grid m-3 gap-3 md:grid-cols-6 lg:grid-cols-12">
          <div className="min-h-[100px] p-2 md:col-span-6 lg:col-span-8">
            <div className="grid m-3 gap-2 grid-cols-1">
              {/* <div className="bg-white-500 p-2 h-full w-full col-span-1 rounded-lg">
              <h1 className="text-center text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
                What You Will Get Inside!
              </h1>
            </div> */}
              <div className="p-3 ml-auto mr-auto text-center">
                <h2 style={{ fontSize: "45px", color: "black" }}>
                  What You Will Get Inside!
                </h2>
              </div>
            </div>
            <div className="grid m-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-2">
              <div className="col-span-2 bg-white-500 shadow">
                {/* First Card */}
                <div className="aminated-card">
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Expense Tracking",
                        " Details about Expense Tracking where User Can calculate their Credit And Debit balance."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "none",
                      borderRadius: "0.5rem",
                      padding: "15px",
                    }}
                    front={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    {/* Content for Front */}
                    <img
                      src={ExpenseImage}
                      alt="Expense Tracking"
                      className="w-full h-auto object-cover"
                    />
                    <div className="p-1 text-center">
                      <span className="text-xl">
                        Expense Tracking&nbsp;&nbsp;
                      </span>
                    </div>
                  </AnimatedCard>
                </div>
              </div>
              <div className="col-span-2 bg-white-500 shadow">
                {/* second Card */}
                <div className="aminated-card">
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Quantity Tracking",

                        " Here User can Manage Item Quantity and show the item quantity and their amount."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "none",
                      borderRadius: "0.5rem",
                      padding: "15px",
                    }}
                    front={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    {/* Content for Front */}
                    <img
                      src={QuantityImage}
                      alt="Quantity Tracking"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1 text-center">
                      <span className="text-xl">
                        Quantity Tracking&nbsp;&nbsp;
                      </span>
                    </div>
                  </AnimatedCard>
                </div>
              </div>
              <div className="col-span-2 bg-white-500 shadow">
                {/* third Card */}
                <div className="aminated-card">
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Notes management",

                        "User in this page make a imporant notes and show in diffrent colours with the imformation."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "none",
                      borderRadius: "0.5rem",
                      padding: "15px",
                    }}
                    front={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    {/* Content for Front */}
                    <img
                      src={NotesImage}
                      alt="Notes Management"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1 text-center">
                      <span className="text-xl">Notes Management</span>
                    </div>
                  </AnimatedCard>
                </div>
              </div>
              <div className="col-span-2 bg-white-500 shadow">
                {/* forth Card */}
                <div className="aminated-card">
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Document Management",
                        "Here User save ,Edit and also delete Important Documents which is save by User."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "none",
                      borderRadius: "0.5rem",
                      padding: "15px",
                    }}
                    front={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    {/* Content for Front */}
                    <img
                      src={DocumentImage}
                      alt="Document Management"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1 text-center">
                      <span className="text-xl">Document Management</span>
                    </div>
                  </AnimatedCard>
                </div>
              </div>
              <div className="col-span-2 bg-white-500 shadow">
                {/* fifth Card */}
                <div className="aminated-card">
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Marketing Management",
                        " In this functioality, user can verify any Email(Valid or Inavalid), also add message logs and reply messages in threads."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "none",
                      borderRadius: "0.5rem",
                      padding: "15px",
                    }}
                    front={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    {/* Content for Front */}
                    <img
                      src={MarketingImage}
                      alt="Marketing Management"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1 text-center">
                      <span className="text-xl">Marketing Management</span>
                    </div>
                  </AnimatedCard>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white min-h-[100px] p-2 md:col-span-6 lg:col-span-4">
            <div className="grid m-3 gap-2">
              <div className="col-span-2 bg-white-500 p-2 h-full rounded-lg shadow">
                {/*  */}
                <div className="w-full">
                  <div className="break-words">
                    <div className="rounded-t mb-0 px-6 py-6">
                      <div className="text-center mb-3">
                        <h2 className="text-blueGray-800 text-2xl font-bold">
                          Sign in to your account
                        </h2>
                      </div>
                      <hr className="mt-6 border-b-1 border-blueGray-300" />
                    </div>
                    <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                      <form onSubmit={handleSubmit}>
                        <div className="relative w-full mb-3">
                          <label
                            className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                            htmlFor="userName"
                          >
                            Username or email
                          </label>
                          <input
                            type="text"
                            name="userName"
                            ref={userNameInputRef}
                            value={formData.userName}
                            onChange={handleChange}
                            className=" border rounded w-full"
                            placeholder="Username or email address"
                          />
                          {errors.userName && (
                            <p style={{ color: "red" }}>{errors.userName}</p>
                          )}
                        </div>
                        <div className="relative w-full mb-3">
                          <label
                            className="block uppercase  text-blueGray-600 text-xs font-bold mb-2"
                            htmlFor="password"
                          >
                            Password
                          </label>
                          <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className=" border rounded w-full"
                            placeholder="Password"
                          />
                          {errors.password && (
                            <p style={{ color: "red" }}>{errors.password}</p>
                          )}
                        </div>
                        <div className="text-center mt-6">
                          <button
                            className="text-white text-sm font-bold uppercase px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                            type="submit"
                            style={{ background: "#0065e6" }}
                          >
                            Sign In
                          </button>
                        </div>
                        <div className="w-full flex flex-wrap mt-6 relative justify-between">
                          <div>
                            <Link
                              to="/forgotpassword"
                              className="text-blue-500"
                            >
                              <small>Forgot Password?</small>
                            </Link>
                          </div>
                          <div className="ml-auto">
                            <Link to="/userRegister" className="text-blue-500">
                              <small>Don't have an account? Sign Up</small>
                            </Link>
                          </div>
                          <BlockUiOverlay visible={loading} />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* old code */}
      {/* <div>
        <div className="mb-3 h-full">
          <div className="flex mx-2 flex-wrap">
            <div className=" md:block w-full xl:w-8/12 xl:mb-0">
              <div className="p-12 ml-auto mr-auto text-center">
                <h2 style={{ fontSize: "45px", color: "black" }}>
                  What you will get inside!
                </h2>
              </div>

              <div className="flex flex-wrap justify-center">
                <div style={{ marginRight: "20px", marginTop: "20px" }}>
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Expense Tracking",
                        " Details about Expense Tracking where User Can calculate their Credit And Debit balance."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    // 140px
                    style={{
                      width: "180px",
                      padding: "20px",
                      height: "auto", // Adjusted height to accommodate variable content
                      borderRadius: "10px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "white",
                      display: "flex", // Added display flex to ensure proper alignment
                      flexDirection: "column", // Set flex direction to column for stacking items
                      justifyContent: "center", // Center items vertically
                      alignItems: "center", // Center items horizontally
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1", // Allow front content to grow to fill available space
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1", // Allow back content to grow to fill available space
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    <img
                      src={`/assets/img/bank.svg`}
                      alt="Expense Tracking"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">
                        Expense Tracking
                      </h2>
                    </div>
                  </AnimatedCard>
                </div>

                <div style={{ marginRight: "20px", marginTop: "20px" }}>
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Quantity Tracking",

                        " Here User can Manage Item Quantity and show the item quantity and their amount."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "180px",
                      padding: "20px",
                      height: "auto", // Adjusted height to accommodate variable content
                      borderRadius: "10px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "white",
                      display: "flex", // Added display flex to ensure proper alignment
                      flexDirection: "column", // Set flex direction to column for stacking items
                      justifyContent: "center", // Center items vertically
                      alignItems: "center", // Center items horizontally
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1", // Allow front content to grow to fill available space
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1", // Allow back content to grow to fill available space
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    <img
                      src={`/assets/img/count.svg`}
                      alt="Quantity Tracking"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">
                        Quantity Tracking
                      </h2>
                    </div>
                  </AnimatedCard>
                </div>

                <div style={{ marginRight: "20px", marginTop: "20px" }}>
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Notes management",

                        "User in this page make a imporant notes and show in diffrent colours with the imformation."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "180px",
                      padding: "20px",
                      height: "auto",
                      borderRadius: "10px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "white",
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    <img
                      src={`/assets/img/notebook.svg`}
                      alt="Notes Tracking"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">
                        Notes Management
                      </h2>
                    </div>
                  </AnimatedCard>
                </div>

                <div style={{ marginRight: "20px", marginTop: "20px" }}>
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Document Management",

                        "Here User save ,Edit and also delete Important Documents which is save by User."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "180px",
                      padding: "20px",
                      height: "auto",
                      borderRadius: "10px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "white",
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    <img
                      src={`/assets/img/documents.svg`}
                      alt="Document Management"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">
                        Document Management
                      </h2>
                    </div>
                  </AnimatedCard>
                </div>

                <div style={{ marginRight: "20px", marginTop: "20px" }}>
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Marketing Management",
                        " In this functioality, user can verify any Email(Valid or Inavalid), also add message logs and reply messages in threads."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "180px",
                      padding: "20px",
                      height: "auto",
                      borderRadius: "10px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "white",
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    <img
                      src={`/assets/img/marketing.svg`}
                      alt="Marketing Management"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">
                        Marketing Management
                      </h2>
                    </div>
                  </AnimatedCard>
                </div>
              </div>
            </div>

            <div className="w-full xl:w-4/12 flex items-center justify-center">
              <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                <div className="rounded-t mb-0 px-6 py-6">
                  <div className="text-center mb-3">
                    <h2 className="text-blueGray-800 text-2xl font-bold">
                      Sign in to your account
                    </h2>
                  </div>
                  <hr className="mt-6 border-b-1 border-blueGray-300" />
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                  <form onSubmit={handleSubmit}>
                    <div className="relative w-full mb-3">
                      <label
                        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor="userName"
                      >
                        Username or email
                      </label>
                      <input
                        type="text"
                        name="userName"
                        ref={userNameInputRef}
                        value={formData.userName}
                        onChange={handleChange}
                        className=" border rounded w-full"
                        placeholder="Username or email address"
                      />
                      {errors.userName && (
                        <p style={{ color: "red" }}>{errors.userName}</p>
                      )}
                    </div>
                    <div className="relative w-full mb-3">
                      <label
                        className="block uppercase  text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor="password"
                      >
                        Password
                      </label>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className=" border rounded w-full"
                        placeholder="Password"
                      />
                      {errors.password && (
                        <p style={{ color: "red" }}>{errors.password}</p>
                      )}
                    </div>
                    <div className="text-center mt-6">
                      <button
                        className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                        type="submit"
                      >
                        Sign In
                      </button>
                    </div>
                    <div className="w-full flex flex-wrap mt-6 relative justify-between">
                      <div>
                        <Link to="/forgotpassword" className="text-blue-200">
                          <small>Forgot Password?</small>
                        </Link>
                      </div>
                      <div className="ml-auto">
                        <Link to="/userRegister" className="text-blue-200">
                          <small>Don't have an account? Sign Up</small>
                        </Link>
                      </div>
                      <BlockUiOverlay visible={loading} />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <Footer />
    </>
  );
}
